// extracted by mini-css-extract-plugin
export var textarea = "textarea-module--textarea--91752";
export var wrapper = "textarea-module--wrapper--9499a";